import React, { useState, useEffect, useRef } from 'react';
import './TransformerOne.css';
import TransformerTwo from "./TransformerTwo";
import Transformer2Two from "./Transformer2Two";
import CreateReport from "./CreateReport";
import { API_URL } from './API';

const TransformerOne = ({ block, plant, project, goBack }) => {

  const [showTestPage, setShowTestPage] = useState(false);
  const isDirty = useRef(false);

  const initialFormData = {
    description: '',
    date: '',
    customer: '',
    project: '',
    reportNo: '',
    location: '',
    client: '',

    make: '',
    serialNo: '',
    noOfPhase: '',
    yom: '',
    windingMaterial: '',
    tempRiseWinding: '',
    tempRiseOil: '',
    hvVolts: '33000',
    lvVolts: '',
    hvCurrent: '',
    lvCurrent: '',
    phaseConnectionHV: '',
    phaseConnectionLV: '',
    specification: '',
    vectorGroup: '',
    vectorGroupCustom: '',
    normalVectorGroup: '',
    frequency: '50',
    typeOfCooling: '',
    kva: '',
    impedanceVoltage: '',
    hvLineCurrent: '',
    lvVoltAcross: '',
    numberOfTaps: '5',
    tap: '3',
  };

  const [formData, setFormData] = useState(initialFormData);

  const vectorGroupOptions = ['YNd11', 'Dyn11'];
  const frequencyOptions = ['50', '60'];

  const [rows, setRows] = useState([]);
  const [generalInspection, setGeneralInspection] = useState({});
  const [ctData, setCtData] = useState([
    { location: 'LV1', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' },
    { location: 'LV2', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' },
    { location: 'LV3', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' },
    { location: 'LV4', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' },
    { location: 'HV', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' }
  ]);
  const fetchClientName = async (clientId) => {
    try {
      const response = await fetch(`${API_URL}/clients/get_client`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });

      if (response.ok) {
        const result = await response.json();
        let clientsData = [];

        if (Array.isArray(result)) {
          clientsData = result;
        } else if (result.data && Array.isArray(result.data)) {
          clientsData = result.data;
        } else if (result.clients && Array.isArray(result.clients)) {
          clientsData = result.clients;
        }

        const client = clientsData.find(c => c.client_id === clientId || c.id === clientId);
        return client ? client.client_name : "Unknown Client";
      }
    } catch (error) {
    
    }
    return "Unknown Client";
  };



  const [selectedCtLocations, setSelectedCtLocations] = useState({
    LV1: false,
    LV2: false,
    LV3: false,
    LV4: false,
    HV: false
  });


  const handleCtLocationToggle = (location) => {
    isDirty.current = true;
   
    setSelectedCtLocations(prev => {
      const newState = {
        ...prev,
        [location]: !prev[location]
      };
      
      return newState;
    });
  };

  useEffect(() => {
    const loadProjectData = async () => {
      if (project) {
        let clientName = project?.clientName || project?.client_name;


        if (!clientName && project?.client) {
          clientName = await fetchClientName(project.client);
        }

        setFormData(prevData => ({
          ...prevData,
          project: project?.name || '',
          client: clientName || '',

        }));
      }
    };

    loadProjectData();
  }, [project]);


  const loadSavedData = () => {
    try {
      const wasCleared = localStorage.getItem('dataWasCleared');
      const clearTimestamp = localStorage.getItem('clearTimestamp');
      const currentTime = Date.now();


      if (wasCleared === 'true') {
        
        setFormData(initialFormData);
        const defaultRows = generateRowsForTaps('5', '33000', '3', '2.5');
        setRows(defaultRows);
        setGeneralInspection({});
        setSelectedCtLocations({
          LV1: false,
          LV2: false,
          LV3: false,
          LV4: false,
          HV: false
        });
        setCtData([
          { location: 'LV1', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' },
          { location: 'LV2', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' },
          { location: 'LV3', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' },
          { location: 'LV4', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' },
          { location: 'HV', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' }
        ]);


        localStorage.removeItem('dataWasCleared');
        localStorage.removeItem('clearTimestamp');
        isDirty.current = false;
        return;
      }

      const savedData = localStorage.getItem('transformerFormData');
      const savedInspectionData = localStorage.getItem('transformerInspectionData');

      if (wasCleared === 'true' || (!savedData && !savedInspectionData)) {
        
        setFormData(initialFormData);
        const defaultRows = generateRowsForTaps('5', '33000', '3', '2.5');
        setRows(defaultRows);
        setGeneralInspection({});
        setSelectedCtLocations({
          LV1: false,
          LV2: false,
          LV3: false,
          LV4: false,
          HV: false
        });
        setCtData([
          { location: 'LV1', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' },
          { location: 'LV2', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' },
          { location: 'LV3', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' },
          { location: 'LV4', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' },
          { location: 'HV', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' }
        ]);

        if (wasCleared === 'true') {
          localStorage.removeItem('dataWasCleared');
        }
        isDirty.current = false;
        return;
      }

      if (savedData) {
        const parsedData = JSON.parse(savedData);
        if (parsedData.formData) {
          setFormData({
            ...parsedData.formData,
            lvVoltAcross: parsedData.formData.lvVoltAcross || ''
          });

          const savedRows = parsedData.rows || [];
          const numberOfTaps = parsedData.formData.numberOfTaps || '5';
          const hvVolts = parsedData.formData.hvVolts || '33000';
          const normalTap = parsedData.formData.tap || '3';
          const stepPercentage = parsedData.formData.stepPercentage || '2.5';

          const generatedRows = generateRowsForTaps(numberOfTaps, hvVolts, normalTap, stepPercentage, savedRows);
          setRows(generatedRows);
        } else {
          setFormData(initialFormData);
          const defaultRows = generateRowsForTaps('5', '33000', '3', '2.5');
          setRows(defaultRows);
        }

        if (parsedData.generalInspection) {
          setGeneralInspection(parsedData.generalInspection);
        }

        if (parsedData.selectedCtLocations) {
          setSelectedCtLocations(parsedData.selectedCtLocations);
        }

        if (parsedData.ctData && Array.isArray(parsedData.ctData)) {
          const defaultCtRow = { location: '', currentRatio: '', accClass: '', burden: '', imagAtVk: '', rct: '', vkMin: '' };
          const fullCtData = [
            parsedData.ctData[0] || { ...defaultCtRow, location: 'LV1' },
            parsedData.ctData[1] || { ...defaultCtRow, location: 'LV2' },
            parsedData.ctData[2] || { ...defaultCtRow, location: 'LV3' },
            parsedData.ctData[3] || { ...defaultCtRow, location: 'LV4' },
            parsedData.ctData[4] || { ...defaultCtRow, location: 'HV' }
          ];
          setCtData(fullCtData);
        }
       
        isDirty.current = false;
      }
    } catch (error) {
     
      setFormData(initialFormData);
      const defaultRows = generateRowsForTaps('5', '33000', '3', '2.5');
      setRows(defaultRows);
      isDirty.current = false;
    }
  };






  useEffect(() => {
    loadSavedData();
  }, []);


  useEffect(() => {
    if (!showTestPage) {
      loadSavedData();
    }
  }, [showTestPage]);


  useEffect(() => {
    const saveDataToLocalStorage = () => {
      if (!isDirty.current) {
        return;
      }


      if (localStorage.getItem('dataWasCleared') === 'true') {
       
        return;
      }

      try {
        const dataToSave = {
          formData,
          rows,
          generalInspection,
          ctData,
          selectedCtLocations
        };
        localStorage.setItem('transformerFormData', JSON.stringify(dataToSave));
       
      } catch (error) {
        
      }
    };

    if (rows.length > 0) {
      saveDataToLocalStorage();
    }
  }, [formData, rows, generalInspection, ctData, selectedCtLocations]);


  const generateRowsForTaps = (numberOfTaps, hvVolts, normalTapPosition, stepPercentage, existingRows = []) => {
    const numTaps = parseInt(numberOfTaps) || 5;
    const baseVoltage = parseFloat(hvVolts) || 33000;
    const normalTap = parseInt(normalTapPosition) || Math.ceil(numTaps / 2);
    const stepPercent = parseFloat(stepPercentage) || 2.5;
    const stepVoltage = (baseVoltage * stepPercent) / 100;

    const newRows = [];

    for (let i = 0; i < numTaps; i++) {
      const tapPosition = i + 1;
      const stepsFromNormal = tapPosition - normalTap;
      let voltageValue = baseVoltage + (stepsFromNormal * -stepVoltage);

      let percentage;
      if (stepsFromNormal === 0) {
        percentage = "Normal";
      } else {
        percentage = stepsFromNormal < 0 ?
          `+${Math.abs(stepsFromNormal) * stepPercent}%` :
          `-${Math.abs(stepsFromNormal) * stepPercent}%`;
      }

      const existingRowData = existingRows[i] || {};


      newRows.push({
        switchPos: `Tap ${tapPosition}`,
        conn: existingRowData.conn || '',
        hvVoltAcross: existingRowData.hvVoltAcross || voltageValue.toFixed(0),
        hvLineCurrent: existingRowData.hvLineCurrent || '',
        lvVoltAcross: existingRowData.lvVoltAcross || '',
        percentage: percentage
      });
    }

    return newRows;
  };




  useEffect(() => {
    if (formData.numberOfTaps && formData.hvVolts) {

      const currentNumTaps = rows.length;
      const newNumTaps = parseInt(formData.numberOfTaps) || 5;


      if (currentNumTaps !== newNumTaps) {
        const newRows = generateRowsForTaps(
          formData.numberOfTaps,
          formData.hvVolts,
          formData.tap,
          formData.stepPercentage,
          rows
        );
        setRows(newRows);
      } else {

        const updatedRows = rows.map((row, index) => {
          const tapPosition = index + 1;
          const normalTap = parseInt(formData.tap) || Math.ceil(newNumTaps / 2);
          const stepsFromNormal = tapPosition - normalTap;
          const baseVoltage = parseFloat(formData.hvVolts) || 33000;
          const stepPercent = parseFloat(formData.stepPercentage) || 2.5;
          const stepVoltage = (baseVoltage * stepPercent) / 100;
          let voltageValue = baseVoltage + (stepsFromNormal * -stepVoltage);


          const calculatedVoltage = voltageValue.toFixed(0);
          const shouldPreserveValue = row.hvVoltAcross && row.hvVoltAcross !== calculatedVoltage;

          return {
            ...row,
            hvVoltAcross: shouldPreserveValue ? row.hvVoltAcross : (row.hvVoltAcross || calculatedVoltage)
          };
        });
        setRows(updatedRows);
      }

      const numTaps = parseInt(formData.numberOfTaps);
      if (parseInt(formData.tap) > numTaps || !formData.tap) {
        setFormData(prevData => ({
          ...prevData,
          tap: Math.ceil(numTaps / 2).toString()
        }));
      }
    }
  }, [formData.numberOfTaps, formData.hvVolts, formData.tap, formData.stepPercentage]);

  const validateDescription = (value) => {
    return value.replace(/[0-9]/g, '');
  };

  const validateReportNoLocation = (value) => {
    return value.replace(/[^a-zA-Z0-9\-]/g, '');
  };

  const validateCustomerClient = (value) => {
    return value.replace(/[^a-zA-Z\s]/g, '');
  };

  const validateProject = (value) => {
    return value.replace(/[^a-zA-Z0-9\s]/g, '');
  };

  const validateLocation = (value) => {
    return value.replace(/[^a-zA-Z0-9\-\s]/g, '');
  };

  const validateMakeWindingMaterial = (value) => {
    return value.replace(/[^a-zA-Z\s]/g, '');
  };

  const validateSerialNoPhaseYom = (value) => {
    return value.replace(/[^0-9]/g, '');
  };

  const validateYom = (value) => {
    const numbersOnly = value.replace(/[^0-9]/g, '');
    const limitedValue = numbersOnly.substring(0, 4);

    if (limitedValue.length === 4) {
      const currentYear = new Date().getFullYear();
      const enteredYear = parseInt(limitedValue);

      if (enteredYear > currentYear) {
        alert("YOM should not be greater than the current year.");
        return formData.yom;
      }
    }

    return limitedValue;
  };

  const validateTempRise = (value) => {
    return value.replace(/[^a-zA-Z0-9°C\s]/g, '');
  };

  const validateHvLvVolts = (value, allowForwardSlash = false) => {
    const regex = allowForwardSlash ? /[^a-zA-Z0-9\/\s]/g : /[^a-zA-Z0-9\s]/g;
    return value.replace(regex, '');
  };

  const validateCurrentAndConnection = (value) => {
    return value;
  };

  const validateSpecification = (value) => {
    return value.replace(/[^a-zA-Z0-9\-\s]/g, '');
  };

  const validateNormalVectorGroup = (value) => {
    return value.replace(/[^a-zA-Z0-9\s]/g, '');
  };

  const validateTypeOfCooling = (value) => {
    return value.replace(/[^a-zA-Z\s]/g, '');
  };

  const validateVA = (value) => {
    return value.replace(/[^0-9]/g, '');
  };

  const validateImpedanceVoltage = (value) => {
    return value.replace(/[^0-9.%]/g, '');
  };

  const validateConn = (value) => {
    return value.replace(/[^0-9&-]/g, '');
  };

  const validateHvLineCurrent = (value) => {
    return value.replace(/[^0-9.]/g, '');
  };

  const validateLvLineCurrent = (value) => {
    return value.replace(/[^a-zA-Z0-9\s]/g, '');
  };

  const validateNumber = (value) => {
    return value.replace(/[^0-9.]/g, '');
  };

  const handleInputChange = (e) => {
    isDirty.current = true;
    const { name, value } = e.target;
    let validatedValue = value;

    switch (name) {
      case 'description':
        validatedValue = validateDescription(value);
        break;
      case 'reportNo':
        validatedValue = validateReportNoLocation(value);
        break;
      case 'customer':
      case 'client':
        validatedValue = validateCustomerClient(value);
        break;
      case 'project':
        validatedValue = validateProject(value);
        break;
      case 'location':
        validatedValue = validateLocation(value);
        break;
      case 'make':
      case 'windingMaterial':
        validatedValue = validateMakeWindingMaterial(value);
        break;
      case 'serialNo':
      case 'noOfPhase':
        validatedValue = validateSerialNoPhaseYom(value);
        break;
      case 'yom':
        validatedValue = validateYom(value);
        break;
      case 'tempRiseWinding':
      case 'tempRiseOil':
        validatedValue = validateTempRise(value);
        break;
      case 'hvVolts':
        validatedValue = validateHvLvVolts(value);
        break;
      case 'lvVolts':
        validatedValue = validateHvLvVolts(value, true);
        break;
      case 'hvCurrent':
      case 'lvCurrent':
      case 'phaseConnectionHV':
      case 'phaseConnectionLV':
        validatedValue = validateCurrentAndConnection(value);
        break;
      case 'specification':
        validatedValue = validateSpecification(value);
        break;
      case 'normalVectorGroup':
        validatedValue = validateNormalVectorGroup(value);
        break;
      case 'typeOfCooling':
        validatedValue = validateTypeOfCooling(value);
        break;
      case 'kva':
        validatedValue = validateVA(value);
        break;
      case 'impedanceVoltage':
        validatedValue = validateImpedanceVoltage(value);
        break;
      case 'hvLineCurrent':
        validatedValue = validateHvLineCurrent(value);
        break;
      case 'lvVoltAcross':
        validatedValue = validateLvLineCurrent(value);
        break;
      case 'stepPercentage':
        validatedValue = validateNumber(value);
        break;
      case 'numberOfTaps':
        const numTaps = parseInt(value) || 1;
        let middleTap;

        if (numTaps === 1) {
          middleTap = 1;
        } else if (numTaps % 2 === 1) {
          middleTap = Math.ceil(numTaps / 2);
        } else {
          middleTap = numTaps / 2;
        }

        setFormData(prevData => ({
          ...prevData,
          [name]: value,
          tap: middleTap.toString()
        }));

        const newRows = generateRowsForTaps(
          value,
          formData.hvVolts,
          middleTap.toString(),
          formData.stepPercentage
        );
        setRows(newRows);
        return;
      default:
        break;
    }

    setFormData(prevData => ({
      ...prevData,
      [name]: validatedValue
    }));
  };




  const handleVectorGroupChange = (e) => {
    isDirty.current = true;
    const value = e.target.value;
    setFormData(prevData => ({
      ...prevData,
      vectorGroup: value,
      vectorGroupCustom: value === 'Other' ? prevData.vectorGroupCustom : ''
    }));
  };

  const handleCustomVectorGroupChange = (e) => {
    isDirty.current = true;
    const value = e.target.value;
    const validatedValue = validateNormalVectorGroup(value);
    setFormData(prevData => ({
      ...prevData,
      vectorGroupCustom: validatedValue
    }));
  };

  const handleRowChange = (index, field, value) => {
    isDirty.current = true;
    if (index < 0 || index >= rows.length) {
     
      return;
    }

    let validatedValue = value;

    switch (field) {
      case 'conn':
        validatedValue = validateConn(value);
        break;
      case 'hvVoltAcross':
        validatedValue = validateHvLvVolts(value);
        break;
      case 'hvLineCurrent':
        validatedValue = validateHvLineCurrent(value);
        break;
      case 'lvVoltAcross':
        validatedValue = validateLvLineCurrent(value);
        break;
      default:
        break;
    }

    setRows(prevRows => {
      if (!Array.isArray(prevRows) || index >= prevRows.length) {
      
        return prevRows;
      }

      const updatedRows = [...prevRows];
      updatedRows[index] = {
        ...updatedRows[index],
        [field]: validatedValue
      };
      return updatedRows;
    });
  };

  const handleCtDataChange = (index, field, value) => {
    isDirty.current = true;
    const updatedCtData = [...ctData];
    updatedCtData[index][field] = value;
    setCtData(updatedCtData);
  };

  const redirectToHome = () => {
    if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {
      localStorage.setItem('openReportsOnLoad', 'true');
      window.location.href = "/";
    }
  };

  const handleBack = () => {
    const dataToSave = {
      formData,
      rows,
      generalInspection,
      ctData,
      selectedCtLocations
    };
    localStorage.setItem('transformerFormData', JSON.stringify(dataToSave));
    if (goBack) {
      goBack();
    }
  };


  const handleNext = () => {
    if (!rows || rows.length === 0) {
      
      alert('Please wait for the form to load properly before proceeding.');
      return;
    }

    const finalVectorGroup = formData.vectorGroup === 'Other' ? formData.vectorGroupCustom : formData.vectorGroup;

    const updatedFormData = {
      ...formData,
      vectorGroup: finalVectorGroup
    };

    const formattedRows = rows.map((row, index) => {
      if (!row) {
       
        return {
          switchPos: `Tap ${index + 1}`,
          conn: '',
          hvVoltAcross: '',
          hvLineCurrent: formData.hvLineCurrent || '',
          lvVoltAcross: formData.lvVoltAcross || ''
        };
      }

      return {
        switchPos: row.switchPos || `Tap ${index + 1}`,
        conn: row.conn || '',
        hvVoltAcross: row.hvVoltAcross || '',
        hvLineCurrent: row.hvLineCurrent || formData.hvLineCurrent || '',
        lvVoltAcross: formData.lvVoltAcross || ''
      };
    });

    const completeData = {
      formData: updatedFormData,
      rows: formattedRows,
      generalInspection: generalInspection || {},
      ctData: ctData
    };

    localStorage.setItem('transformerFormData', JSON.stringify(completeData));
    localStorage.setItem('transformerCompleteData', JSON.stringify(completeData));


    setShowTestPage(true);
  };

  const handleClearData = () => {
    if (window.confirm("Are you sure you want to clear all saved data? This action cannot be undone.")) {
      localStorage.removeItem('transformerFormData');
      localStorage.removeItem('transformerCompleteData');
      window.location.reload();
    }
  };



  if (showTestPage) {
    const finalVectorGroup = formData.vectorGroup === 'Other' ? formData.vectorGroupCustom : formData.vectorGroup;

  
    if (finalVectorGroup && finalVectorGroup.toLowerCase() === 'dyn11') {
      return <Transformer2Two
        goBack={() => {
          loadSavedData();
          setShowTestPage(false);
        }}
        savedGeneralData={{
          formData: { ...formData, vectorGroup: finalVectorGroup },
          rows,
          generalInspection,
          ctData
        }}
        project={formData.project}
        block={formData.location}
        plant={formData.client}
      />;
    } else {
      return <TransformerTwo
        goBack={() => {
          loadSavedData();
          setShowTestPage(false);
        }}
        savedGeneralData={{
          formData: { ...formData, vectorGroup: finalVectorGroup },
          rows,
          generalInspection,
          ctData
        }}
      />;
    }
  }

  return (
    <div className="ct-2746">
      <span
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          fontSize: '20px',
          fontWeight: '600',
          color: '#333',
          cursor: 'pointer',
          marginLeft: '50px',
          marginBottom: '50px'
        }}
        onClick={redirectToHome}
      >
        X
      </span>


      <div className="ct-2747">
        <h3>TRANSFORMER INSPECTION / TEST REPORT</h3>
      </div>

      <div className="ct-2748">
        <div className="ct-2749">
          <div className="ct-2750">
            <label>Description</label>
            <input
              type="text"
              name="description"
              value="TRANSFORMERS INSPECTION / TEST REPORT"
              onChange={handleInputChange}
              placeholder="Enter Description"
              readOnly={"description"}
              style={"description" ? {

                cursor: 'not-allowed'
              } : {}}
            />
          </div>

          <div className="ct-2750">
            <label>Date</label>
            <div className="ct-2751">
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleInputChange}
                placeholder="Select Date"
                className="date-input"
              />
            </div>
          </div>

          <div className="ct-2750">
            <label>Customer</label>
            <input
              type="text"
              name="customer"
              value={formData.customer}
              onChange={handleInputChange}
              placeholder="Enter Customer"
            />
          </div>
        </div>

        <div className="ct-2749">
          <div className="ct-2750">
            <label>Project</label>
            <div className="ct-2752">
              <input
                type="text"
                name="project"
                value={formData.project}
                onChange={handleInputChange}
                placeholder="Enter Project"
                readOnly={"project"}
                style={"project" ? {

                  cursor: 'not-allowed'
                } : {}}
              />
            </div>
          </div>

          <div className="ct-2750">
            <label>Report No</label>
            <input
              type="text"
              name="reportNo"
              value={formData.reportNo}
              onChange={handleInputChange}
              placeholder="Enter Report"
            />
          </div>

          <div className="ct-2750">
            <label>Location</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              placeholder="Enter Location"

            />
          </div>
        </div>

        <div className="ct-2749">
          <div className="ct-2750">
            <label>Client</label>
            <input
              type="text"
              name="client"
              value={formData.client}
              onChange={handleInputChange}
              placeholder="Enter Client"
              readOnly={"client"}
              style={"client" ? {

                cursor: 'not-allowed'
              } : {}}
            />
          </div>
          <div className="ct-2750"></div>
          <div className="ct-2750"></div>
        </div>
      </div>

      <div className="ct-2753">
        <h3>NAME PLATE DETAILS</h3>

        <div className="ct-2749">
          <div className="ct-2750">
            <label>Make</label>
            <input
              type="text"
              name="make"
              value={formData.make}
              onChange={handleInputChange}
              placeholder="Enter Make"
            />
          </div>

          <div className="ct-2750">
            <label>Serial No</label>
            <input
              type="text"
              name="serialNo"
              value={formData.serialNo}
              onChange={handleInputChange}
              placeholder="Enter Serial No"
            />
          </div>

          <div className="ct-2750">
            <label>No.of Phase</label>
            <input
              type="text"
              name="noOfPhase"
              value={formData.noOfPhase}
              onChange={handleInputChange}
              placeholder="Enter No of Phase"
            />
          </div>

          <div className="ct-2750">
            <label>YOM (Year of Manufacturing)</label>
            <input
              type="text"
              name="yom"
              value={formData.yom}
              onChange={handleInputChange}
              placeholder="Enter YOM"
            />
          </div>
        </div>

        <div className="ct-2749">
          <div className="ct-2750">
            <label>Winding Material</label>
            <input
              type="text"
              name="windingMaterial"
              value={formData.windingMaterial}
              onChange={handleInputChange}
              placeholder="Enter Winding Material"
            />
          </div>

          <div className="ct-2750">
            <label>TEMP. RISE WINDING</label>
            <input
              type="text"
              name="tempRiseWinding"
              value={formData.tempRiseWinding}
              onChange={handleInputChange}
              placeholder="Enter Temp Rise Winding"
            />
          </div>

          <div className="ct-2750">
            <label>TEMP. RISE OIL</label>
            <input
              type="text"
              name="tempRiseOil"
              value={formData.tempRiseOil}
              onChange={handleInputChange}
              placeholder="Enter TEMP RISE OIL"
            />
          </div>
        </div>

        <div className="ct-2749">
          <div className="ct-2750">
            <label>Number of Taps</label>
            <select
              name="numberOfTaps"
              value={formData.numberOfTaps}
              onChange={handleInputChange}
              className="taps-select"
            >
              {[1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35, 37, 39, 41, 43, 45, 47, 49, 51, 52].map(num => (
                <option key={num} value={num}>{num}</option>
              ))}
            </select>
          </div>

          <div className="ct-2750">
            <label>Normal Tap No.</label>
            <select
              name="tap"
              value={formData.tap}
              onChange={handleInputChange}
              placeholder="Enter Normal Tap No."
            >
              {Array.from({ length: parseInt(formData.numberOfTaps) || 5 }, (_, i) => i + 1).map(num => (
                <option key={num} value={num}>{num}</option>
              ))}
            </select>
          </div>

        </div>

        <div className="ct-2749">
          <div className="ct-2750 ct-2754">
            <label>VOLT AT NO LOAD</label>
            <div className="ct-2755">
              <div>
                <small>H.V. VOLTS</small>
                <input
                  type="text"
                  name="hvVolts"
                  value={formData.hvVolts}
                  onChange={handleInputChange}
                  placeholder="VOLT NO LOAD HV VOLTS"
                />
              </div>
              <div>
                <small>L.V. VOLTS</small>
                <input
                  type="text"
                  name="lvVolts"
                  value={formData.lvVolts}
                  onChange={handleInputChange}
                  placeholder="(V1/V2/V3)"
                />
              </div>
            </div>
          </div>

          <div className="ct-2750 ct-2754">
            <label>LINE AMPERE</label>
            <div className="ct-2755">
              <div>
                <small>H.V. CURRENT</small>
                <input
                  type="text"
                  name="hvCurrent"
                  value={formData.hvCurrent}
                  onChange={handleInputChange}
                  placeholder="ENTER LINE AMPERE HV CURRENT (A1/A2/A3)"
                />
              </div>
              <div>
                <small>L.V. CURRENT</small>
                <input
                  type="text"
                  name="lvCurrent"
                  value={formData.lvCurrent}
                  onChange={handleInputChange}
                  placeholder="(I1/I2/I3)"
                />
              </div>
            </div>
          </div>

          <div className="ct-2750">
            <label>Phase & Connection</label>
            <div className="ct-2756">
              <div>
                <small>HV</small>
                <input
                  type="text"
                  name="phaseConnectionHV"
                  value={formData.phaseConnectionHV}
                  onChange={handleInputChange}
                  placeholder="Enter Phase-Connection HV"
                />
              </div>
              <div>
                <small>LV</small>
                <input
                  type="text"
                  name="phaseConnectionLV"
                  value={formData.phaseConnectionLV}
                  onChange={handleInputChange}
                  placeholder="Enter Phase-Connection LV"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="ct-2749">
          <div className="ct-2750">
            <label>Specification</label>
            <input
              type="text"
              name="specification"
              value={formData.specification}
              onChange={handleInputChange}
              placeholder="Enter Specification"
            />
          </div>

          <div className="ct-2750">
            <label>Vector Group</label>
            <div className="vector-group-container" style={{ display: 'flex', gap: '10px' }}>
              <select
                name="vectorGroup"
                value={formData.vectorGroup}
                onChange={handleVectorGroupChange}
                style={{ flex: '1' }}
              >
                <option value="">Select Vector Group</option>
                {vectorGroupOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}

              </select>

              {formData.vectorGroup === 'Other' && (
                <input
                  type="text"
                  name="vectorGroupCustom"
                  value={formData.vectorGroupCustom}
                  onChange={handleCustomVectorGroupChange}
                  placeholder="Enter Custom Vector Group"
                  style={{ flex: '1' }}
                />
              )}
              <input
                type="text"
                name="normalVectorGroup"
                value={formData.normalVectorGroup}
                onChange={handleInputChange}
                placeholder="Enter Normal Vector"
              />
            </div>
          </div>



          <div className="ct-2750">
            <label>Frequency</label>
            <select
              name="frequency"
              value={formData.frequency}
              onChange={handleInputChange}
              placeholder="Select Frequency"
            >
              {frequencyOptions.map(option => (
                <option key={option} value={option}>{option} Hz</option>
              ))}
            </select>
          </div>
        </div>

        <div className="ct-2749">
          <div className="ct-2750">
            <label>Type of cooling</label>
            <input
              type="text"
              name="typeOfCooling"
              value={formData.typeOfCooling}
              onChange={handleInputChange}
              placeholder="Enter Type of cooling"
            />
          </div>

          <div className="ct-2750">
            <label>VA</label>
            <input
              type="text"
              name="kva"
              value={formData.kva}
              onChange={handleInputChange}
              placeholder="Enter VA"
            />
          </div>

          <div className="ct-2750 ct-2757">
            <label>%Impedance voltage@ 75 Deg C</label>
            <input
              type="text"
              name="impedanceVoltage"
              value={formData.impedanceVoltage}
              onChange={handleInputChange}
              placeholder="Enter %"
            />
          </div>
        </div>
        <div className="ct-2765">
          <div className="ct-2766">
            <div className="ct-2767">Location</div>
          </div>


          <div className="ct-3018">
            <div
              className={`ct-3019 ${selectedCtLocations.LV1 ? 'ct-3020' : ''}`}
              onClick={() => handleCtLocationToggle('LV1')}
              style={{ cursor: 'pointer', userSelect: 'none' }}
            >
              <div className="ct-3004">LV1</div>
            </div>

            {selectedCtLocations.LV1 && (
              <div className="ct-3005">
                <div className="ct-2766" style={{ marginBottom: '10px' }}>
                  <div className="ct-2767">Current Ratio</div>
                  <div className="ct-2767">Acc. Class</div>
                  <div className="ct-2767">BURDEN</div>
                  <div className="ct-2767">Imag.AT Vk /2</div>
                  <div className="ct-2767">RCT (Ohm)</div>
                  <div className="ct-2767">Vk min</div>
                </div>

                <div className="ct-2768">
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Current Ratio"
                      value={ctData[0]?.currentRatio || ''}
                      onChange={(e) => handleCtDataChange(0, 'currentRatio', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Acc Class"
                      value={ctData[0]?.accClass || ''}
                      onChange={(e) => handleCtDataChange(0, 'accClass', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Burden"
                      value={ctData[0]?.burden || ''}
                      onChange={(e) => handleCtDataChange(0, 'burden', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Imag. AT Vk /2"
                      value={ctData[0]?.imagAtVk || ''}
                      onChange={(e) => handleCtDataChange(0, 'imagAtVk', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter RCT (Ohm)"
                      value={ctData[0]?.rct || ''}
                      onChange={(e) => handleCtDataChange(0, 'rct', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Vk min"
                      value={ctData[0]?.vkMin || ''}
                      onChange={(e) => handleCtDataChange(0, 'vkMin', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>


          <div className="ct-3018">
            <div
              className={`ct-3019 ${selectedCtLocations.LV2 ? 'ct-3020' : ''}`}
              onClick={() => handleCtLocationToggle('LV2')}
              style={{ cursor: 'pointer', userSelect: 'none' }}
            >
              <div className="ct-3004">LV2</div>
            </div>

            {selectedCtLocations.LV2 && (
              <div className="ct-3005">
                <div className="ct-2766" style={{ marginBottom: '10px' }}>
                  <div className="ct-2767">Current Ratio</div>
                  <div className="ct-2767">Acc. Class</div>
                  <div className="ct-2767">BURDEN</div>
                  <div className="ct-2767">Imag.AT Vk /2</div>
                  <div className="ct-2767">RCT (Ohm)</div>
                  <div className="ct-2767">Vk min</div>
                </div>

                <div className="ct-2768">
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Current Ratio"
                      value={ctData[1]?.currentRatio || ''}
                      onChange={(e) => handleCtDataChange(1, 'currentRatio', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Acc Class"
                      value={ctData[1]?.accClass || ''}
                      onChange={(e) => handleCtDataChange(1, 'accClass', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Burden"
                      value={ctData[1]?.burden || ''}
                      onChange={(e) => handleCtDataChange(1, 'burden', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Imag. AT Vk /2"
                      value={ctData[1]?.imagAtVk || ''}
                      onChange={(e) => handleCtDataChange(1, 'imagAtVk', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter RCT (Ohm)"
                      value={ctData[1]?.rct || ''}
                      onChange={(e) => handleCtDataChange(1, 'rct', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Vk min"
                      value={ctData[1]?.vkMin || ''}
                      onChange={(e) => handleCtDataChange(1, 'vkMin', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>


          <div className="ct-3018">
            <div
              className={`ct-3019 ${selectedCtLocations.LV3 ? 'ct-3020' : ''}`}
              onClick={() => handleCtLocationToggle('LV3')}
              style={{ cursor: 'pointer', userSelect: 'none' }}
            >
              <div className="ct-3004">LV3</div>
            </div>

            {selectedCtLocations.LV3 && (
              <div className="ct-3005">
                <div className="ct-2766" style={{ marginBottom: '10px' }}>
                  <div className="ct-2767">Current Ratio</div>
                  <div className="ct-2767">Acc. Class</div>
                  <div className="ct-2767">BURDEN</div>
                  <div className="ct-2767">Imag.AT Vk /2</div>
                  <div className="ct-2767">RCT (Ohm)</div>
                  <div className="ct-2767">Vk min</div>
                </div>

                <div className="ct-2768">
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Current Ratio"
                      value={ctData[2]?.currentRatio || ''}
                      onChange={(e) => handleCtDataChange(2, 'currentRatio', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Acc Class"
                      value={ctData[2]?.accClass || ''}
                      onChange={(e) => handleCtDataChange(2, 'accClass', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Burden"
                      value={ctData[2]?.burden || ''}
                      onChange={(e) => handleCtDataChange(2, 'burden', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Imag. AT Vk /2"
                      value={ctData[2]?.imagAtVk || ''}
                      onChange={(e) => handleCtDataChange(2, 'imagAtVk', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter RCT (Ohm)"
                      value={ctData[2]?.rct || ''}
                      onChange={(e) => handleCtDataChange(2, 'rct', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Vk min"
                      value={ctData[2]?.vkMin || ''}
                      onChange={(e) => handleCtDataChange(2, 'vkMin', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>


          <div className="ct-3018">
            <div
              className={`ct-3019 ${selectedCtLocations.LV4 ? 'ct-3020' : ''}`}
              onClick={() => handleCtLocationToggle('LV4')}
              style={{ cursor: 'pointer', userSelect: 'none' }}
            >
              <div className="ct-3004">LV4</div>
            </div>

            {selectedCtLocations.LV4 && (
              <div className="ct-3005">
                <div className="ct-2766" style={{ marginBottom: '10px' }}>
                  <div className="ct-2767">Current Ratio</div>
                  <div className="ct-2767">Acc. Class</div>
                  <div className="ct-2767">BURDEN</div>
                  <div className="ct-2767">Imag.AT Vk /2</div>
                  <div className="ct-2767">RCT (Ohm)</div>
                  <div className="ct-2767">Vk min</div>
                </div>

                <div className="ct-2768">
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Current Ratio"
                      value={ctData[3]?.currentRatio || ''}
                      onChange={(e) => handleCtDataChange(3, 'currentRatio', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Acc Class"
                      value={ctData[3]?.accClass || ''}
                      onChange={(e) => handleCtDataChange(3, 'accClass', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Burden"
                      value={ctData[3]?.burden || ''}
                      onChange={(e) => handleCtDataChange(3, 'burden', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Imag. AT Vk /2"
                      value={ctData[3]?.imagAtVk || ''}
                      onChange={(e) => handleCtDataChange(3, 'imagAtVk', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter RCT (Ohm)"
                      value={ctData[3]?.rct || ''}
                      onChange={(e) => handleCtDataChange(3, 'rct', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Vk min"
                      value={ctData[3]?.vkMin || ''}
                      onChange={(e) => handleCtDataChange(3, 'vkMin', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>


          <div className="ct-3018">
            <div
              className={`ct-3019 ${selectedCtLocations.HV ? 'ct-3020' : ''}`}
              onClick={() => handleCtLocationToggle('HV')}
              style={{ cursor: 'pointer', userSelect: 'none' }}
            >
              <div className="ct-3004">HV</div>
            </div>

            {selectedCtLocations.HV && (
              <div className="ct-3005">
                <div className="ct-2766" style={{ marginBottom: '10px' }}>
                  <div className="ct-2767">Current Ratio</div>
                  <div className="ct-2767">Acc. Class</div>
                  <div className="ct-2767">BURDEN</div>
                  <div className="ct-2767">Imag.AT Vk /2</div>
                  <div className="ct-2767">RCT (Ohm)</div>
                  <div className="ct-2767">Vk min</div>
                </div>

                <div className="ct-2768">
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Current Ratio"
                      value={ctData[4]?.currentRatio || ''}
                      onChange={(e) => handleCtDataChange(4, 'currentRatio', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Acc Class"
                      value={ctData[4]?.accClass || ''}
                      onChange={(e) => handleCtDataChange(4, 'accClass', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Burden"
                      value={ctData[4]?.burden || ''}
                      onChange={(e) => handleCtDataChange(4, 'burden', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Imag. AT Vk /2"
                      value={ctData[4]?.imagAtVk || ''}
                      onChange={(e) => handleCtDataChange(4, 'imagAtVk', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter RCT (Ohm)"
                      value={ctData[4]?.rct || ''}
                      onChange={(e) => handleCtDataChange(4, 'rct', e.target.value)}
                    />
                  </div>
                  <div className="ct-2769">
                    <input
                      type="text"
                      placeholder="Enter Vk min"
                      value={ctData[4]?.vkMin || ''}
                      onChange={(e) => handleCtDataChange(4, 'vkMin', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="ct-2758">
        <div className="ct-2759">
          <div className="ct-2760">
            <label>SWITCH POS.</label>
          </div>
          <div className="ct-2761">
            {rows.map((row, index) => (
              <input
                key={`switch-${index}`}
                type="text"
                value={row.switchPos}
                onChange={(e) => handleRowChange(index, 'switchPos', e.target.value)}
                placeholder={`Enter SWITCH POS ${index + 1}`}
                readOnly
              />
            ))}
          </div>
        </div>

        <div className="ct-2759">
          <div className="ct-2760">
            <label>CONN.</label>
          </div>
          <div className="ct-2761">
            {rows.map((row, index) => (
              <input
                key={`conn-${index}`}
                type="text"
                value={row.conn}
                onChange={(e) => handleRowChange(index, 'conn', e.target.value)}
                placeholder={`Enter CONN ${index + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="ct-2759">
          <div className="ct-2760">
            <label>HV VOLT ACROSS(V)</label>
          </div>
          <div className="ct-2761">
            {rows.map((row, index) => (
              <input
                key={`hvVolt-${index}`}
                type="text"
                value={row.hvVoltAcross}
                onChange={(e) => handleRowChange(index, 'hvVoltAcross', e.target.value)}
                placeholder={`Enter HV VOLT ACROSS V ${index + 1}`}
                style={{
                  backgroundColor: row.percentage === "Normal" ? '#e6f7ff' : 'transparent',
                  fontWeight: row.percentage === "Normal" ? 'bold' : 'normal'
                }}
              />
            ))}
          </div>
        </div>

        <div className="ct-2759">
          <div className="ct-2760">
            <label>HV LINE CURRENT (A)</label>
          </div>
          <div className="ct-2761">
            {rows.map((row, index) => (
              <input
                key={`hvLineCurrent-${index}`}
                type="text"
                value={row.hvLineCurrent}
                onChange={(e) => handleRowChange(index, 'hvLineCurrent', e.target.value)}
                placeholder={`Enter HV LINE CURRENT (A) ${index + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="ct-2759">
          <div className="ct-2760">
            <label>LV VOLT ACROSS</label>
          </div>
          <div className="ct-2761">
            <input
              type="text"
              value={formData.lvVoltAcross || ''}
              onChange={(e) => {
                isDirty.current = true;
                setFormData({ ...formData, lvVoltAcross: e.target.value });
              }}
              placeholder="Enter LV VOLT ACROSS"
            />
          </div>
        </div>
      </div>

      <div className="ct-2762">
        <button className="ct-2763" onClick={handleBack}>Back</button>
        <button className="ct-2764" onClick={handleNext}>Next</button>
      </div>
    </div>
  );
};

export default TransformerOne;